
import { Component, Vue, Prop, Watch, InjectReactive, Inject } from "vue-property-decorator"
import { State } from "vuex-class"

import { get, set } from "lodash"

// @ts-ignore
import { Datetime } from "vue-datetime"
import vSelect from "vue-select"

import { getMapStyle } from "@/scripts/mapStyle"

import {
	getEnhancedMapping,
	IEnhancedMapping,
	IMap,
	IMarker,
	ILatLng,
	ILatLngBounds,
	MultiMarker,
	MarkerType
} from "@sureview/v2-mapping"

import { MapProvider, DrawArguments, MarkerDrawType } from "@/services/mapProvider"

@Component({
	components: {
	}
})
export default class MapDisplay extends Vue {
	$refs!: {
		mappingContainer: HTMLElement,
	}

	@Inject("mapProvider") mapProvider!: MapProvider;

	@State darkMode!: boolean;

	public mapKey: string = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "";

	public enhancedMapping: IEnhancedMapping | null = null;
	public map: IMap | null = null;

	private drawArgs: DrawArguments | null = null;
	private currentDrawing: MultiMarker | null = null;

	private markerDrawType = MarkerDrawType;

	get location () {
		return { lat: 0, lng: 0 }
	}

	async mounted () {
		this.enhancedMapping = await getEnhancedMapping("google", this.mapKey)

		const mapStyle = getMapStyle(this.darkMode, "roadmap", false)

		if (this.mapProvider) {
			this.mapProvider.mapStyle = mapStyle
		}

		this.map = this.enhancedMapping.createMap(
			this.$refs.mappingContainer,
			this.location,
			2,
			false,
			"roadmap",
			mapStyle
		)

		this.map!.registerEvent("onClick", this.mapClick)

		if (this.mapProvider) {
			Vue.nextTick().then(() => {
				this.mapProvider.setMapping(this.enhancedMapping!, this.map!)
				this.mapProvider.mapElement = this.$refs.mappingContainer

				if (!this.mapProvider.boundsSet) {
					navigator.geolocation.getCurrentPosition((pos: any) => {
						this.map!.center = {
							lat: pos.coords.latitude,
							lng: pos.coords.longitude
						}
						this.map!.zoom = 16
					})
				}
			})

			this.mapProvider.on("startDraw", this.startDraw)
		}
	}

	beforeDestroy () {
		if (this.mapProvider) {
			this.mapProvider.clearMarkers()
			this.mapProvider.off("startDraw", this.startDraw)
		}

		if (this.currentDrawing) {
			this.currentDrawing.remove()
			this.currentDrawing = null
		}
	}

	startDraw (drawArgs: DrawArguments) {
		this.map!.setCursor("crosshair")
		this.drawArgs = drawArgs
	}

	mapClick (clickLocation: { lat: number, lng: number }) {
		if (this.drawArgs) {
			if (this.drawArgs.drawType === MarkerDrawType.Point) {
				this.drawArgs.set({ ...clickLocation, zoom: this.map!.zoom })
				this.drawArgs = null
				this.map!.setCursor("grab")
			} else {
				if (!this.currentDrawing) {
					const states = (this.drawArgs!.drawType === MarkerDrawType.Path)
						? {
							first: {
								imageUrl: `./images/map/${this.drawArgs.colorName}_small.svg`,
								opacity: 1,
								line: {
									color: this.drawArgs.color,
									linePath: "solid"
								}
							},
							last: {
								imageUrl: `./images/map/${this.drawArgs.colorName}_small.svg`,
								opacity: 1,
								line: {
									color: this.drawArgs.color,
									linePath: "solid"
								}
							}
						}
						: (this.drawArgs!.drawType === MarkerDrawType.Region)
							? {
								first: {
									imageUrl: `./images/map/${this.drawArgs.colorName}_small.svg`,
									opacity: 1,
									line: {
										color: this.drawArgs.color,
										linePath: "solid"
									}
								}
							}
							: {}

					const markerType = new MarkerType({
						imageUrl: `./images/map/${this.drawArgs.colorName}_small.svg`,
						opacity: 0,
						line: {
							color: this.drawArgs.color,
							linePath: "solid"
						}
					}, states)

					this.currentDrawing = new MultiMarker(this.enhancedMapping!,
						this.map!,
						"",
						markerType,
						[clickLocation],
						(clickedMarker: IMarker, index: number) => {
							if (this.drawArgs! && (index === 0 || this.drawArgs!.drawType === MarkerDrawType.Path)) {
								this.finishDrawing()
							}
						}
					)
				} else {
					this.currentDrawing.addPoint(clickLocation)
				}
			}
		} else {
			this.map!.setCursor("grab")
		}
	}

	finishDrawing () {
		if (this.currentDrawing) {
			this.drawArgs!.set(
				this.currentDrawing.lineMarkers.map((marker: IMarker) => marker.position)
			)

			this.currentDrawing.remove()
			this.currentDrawing = null
		}

		this.drawArgs = null
		this.map!.setCursor("grab")
	}
}

